(ns common.schema.entities.workspace.kyc.templates.demo.ubo
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]
   [common.schema.entities.workspace.kyc.templates.demo.pep :as pep]
   [common.schema.entities.workspace.kyc.templates.templates :as templates]))

(def schema
  {:kyc-template/template-name
   "UBO"
   :kyc-template/kyc-form-preface
   {:translations {:en "Ultimate beneficial owners (UBO)"
                   :fi "Yhteisön tosiasialliset edunsaajat"}}

   :kyc-ubo.group/ubo-position
   {:ord          1.0
    :translations {:en "Reason for UBO"
                   :fi "Peruste"}
    :conditional-block (fn [_answers kyc-process]
                         (not (templates/natural-person-templates-keys (:kyc-process/template kyc-process))))
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/primary-ubo-category]
                    [:kyc-ubo/ubo-category-ownership]
                    [:kyc-ubo/ubo-category-voting-rights]
                    [:kyc-ubo/ubo-category-position]])}

   :kyc-ubo.group/basic-information
   {:ord          2.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/last-name]
                    [:kyc-ubo/first-name]
                    [:kyc-ubo/dob]
                    [:kyc-ubo/pob]
                    [:kyc-ubo/cob]
                    [:kyc-ubo/pid]
                    [:kyc-ubo/address]
                    [:kyc-ubo/zip-code]
                    [:kyc-ubo/city]
                    [:kyc-ubo/country]
                    [:kyc-ubo/nationality]])}

   :kyc-ubo.group/tax-residencies
   {:ord          3.0
    :translations {:en "Tax Residency"
                   :fi "Verovelvollisuus"}
    :info         {:en ""
                   :fi "Lisää myös valtiot, joihin henkilö maksaa tulo- tai kiinteistöveroa"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/tax-countries]
                    [:kyc-ubo/usa-tax-residence]
                    [:kyc-ubo/non-usa-confirmation]
                    [:kyc-ubo/usa-confirmation]])}

   :kyc-ubo.group/pep
   {:ord          4.0
    :translations {:en "Politically exposed person"
                   :fi "Poliittinen vaikutusvalta"}
    :info         (->> pep/schema
                       :kyc-pep.group/basic-information
                       :info)
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/pep]
                    [:kyc-ubo.pep/dob
                     {:conditional-field (fn [answers]
                                           (= :yes (:kyc-ubo/pep answers)))}]
                    [:kyc-ubo.pep/birth-country
                     {:conditional-field (fn [answers]
                                           (= :yes (:kyc-ubo/pep answers)))}]
                    [:kyc-ubo.pep/country
                     {:conditional-field (fn [answers]
                                           (= :yes (:kyc-ubo/pep answers)))}]
                    [:kyc-ubo.pep/political-function
                     {:conditional-field (fn [answers]
                                           (= :yes (:kyc-ubo/pep answers)))}]
                    [:kyc-ubo.pep/relationship-to-ubo
                     {:conditional-field (fn [answers]
                                           (= :yes (:kyc-ubo/pep answers)))}]
                    [:kyc-ubo.pep/name
                     {:conditional-field (fn [answers]
                                           (and (= :yes (:kyc-ubo/pep answers))
                                                (some #{(:kyc-ubo.pep/relationship-to-ubo answers)}
                                                      [:family-member :other])))}]
                    [:kyc-ubo.pep/connection-to-investor
                     {:conditional-field (fn [answers kyc-process]
                                           (and (not (templates/natural-person-templates-keys (:kyc-process/template kyc-process)))
                                                (= :yes (:kyc-ubo/pep answers))
                                                (some #{(:kyc-ubo.pep/relationship-to-ubo answers)}
                                                      [:family-member :other])))}]])}
   :kyc-ubo.group/identification
   {:ord          5.0
    :translations {:en "Identification"
                   :fi "Tunnistetiedot"}
    :info         {:en ""
                   :fi ""}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/type-of-identification-attachment]
                    [:kyc-ubo/identification-expires]
                    [:kyc-ubo/identification-attachment]])}})
